import Button from '@/UIlibrary/Button/Button';
import { ChevronLeft } from 'react-feather';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

export default function NotFound() {
	const t = useTranslations('NotFound');
	const navigate = useNavigate();
	const { lang } = useParams<{ lang: string }>();
	const handleGoBack = () => {
		return navigate(-2);
	};

	return (
		<div className="w-full h-screen flex flex-col justify-center items-center">
			<div className="flex flex-col items-center max-w-[40%] text-center grow">
				<div className="flex-1 flex flex-col justify-center items-center gap-8">
					<div className="flex flex-col gap-1">
						<Typography color="brand">{t('Error')}</Typography>
						<Typography type="display" size="md" weight="semibold">
							{t('Title')}
						</Typography>
					</div>
					<div>
						<Typography size="xl" color="subtitle">
							{t('Description')}
						</Typography>
					</div>
					<div className="flex flex-col md:flex-row gap-4 justify-around items-center mt-8">
						<Button
							label={t('Back')}
							color="secondary"
							size="auto"
							onClick={handleGoBack}
							startIcon={<ChevronLeft />}
						/>
						<Link to={`/${lang}`}>
							<Button label={t('Home')} color="primary" size="auto" />
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
